const MODULE_COLUMN_PREFIX = 'assessmentModule:';

export function assessmentModuleColumnId(moduleId) {
  return `${MODULE_COLUMN_PREFIX}${String(moduleId || '')}`;
}

export function parseAssessmentModuleColumnId(columnId) {
  if (!columnId || typeof columnId !== 'string' || !columnId.startsWith(MODULE_COLUMN_PREFIX)) {
    return null;
  }
  const moduleId = columnId.slice(MODULE_COLUMN_PREFIX.length);
  return moduleId || null;
}

export function normalizeAssessmentModulesFromScreening(assessmentRef) {
  if (!assessmentRef || assessmentRef.isMultiModule !== true) {
    return [];
  }
  const mods = Array.isArray(assessmentRef.modules) ? assessmentRef.modules : [];
  return [...mods]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((mod, idx) => {
      const moduleId = String(mod.libraryTestId?._id || mod.libraryTestId || mod.moduleId || '');
      return {
        moduleId,
        title: String(mod.title || `Module ${idx + 1}`).trim(),
        order: mod.order ?? idx,
      };
    })
    .filter((mod) => mod.moduleId);
}

export function buildScreeningAssessmentModuleMeta(screening, multiModuleTableScoresEnabled) {
  if (!multiModuleTableScoresEnabled || !screening) {
    return { showAssessmentModuleColumns: false, assessmentModules: [] };
  }
  const assessmentRef = screening.assessmentId;
  const assessmentModules = normalizeAssessmentModulesFromScreening(
    typeof assessmentRef === 'object' ? assessmentRef : null
  );
  return {
    showAssessmentModuleColumns: assessmentModules.length > 0,
    assessmentModules,
  };
}

export function buildAssessmentModuleColumnChoices(assessmentModules = []) {
  return (assessmentModules || []).map((mod) => ({
    id: assessmentModuleColumnId(mod.moduleId),
    label: mod.title || 'Module',
    description: `Score for the "${mod.title || 'module'}" assessment module.`,
    group: 'Scoring',
    defaultVisible: true,
    available: true,
    moduleId: mod.moduleId,
  }));
}

export function getVisibleAssessmentModuleColumns(screeningMeta, columnVisibility = {}) {
  if (!screeningMeta?.showAssessmentModuleColumns) {
    return [];
  }
  const modules = Array.isArray(screeningMeta.assessmentModules) ? screeningMeta.assessmentModules : [];
  return modules.filter((mod) => {
    const key = assessmentModuleColumnId(mod.moduleId);
    if (Object.prototype.hasOwnProperty.call(columnVisibility, key)) {
      return columnVisibility[key] === true;
    }
    return true;
  });
}

export function findCandidateModuleScore(candidate, moduleId) {
  if (!candidate || !moduleId) return null;
  const scores = Array.isArray(candidate.assessmentModuleScores) ? candidate.assessmentModuleScores : [];
  return (
    scores.find((entry) => String(entry.moduleId) === String(moduleId)) || null
  );
}

export function formatModuleScorePercentage(score, maxScore) {
  if (score == null || maxScore == null || maxScore <= 0) return null;
  return Math.round((score / maxScore) * 100);
}

export function formatModuleScoreRaw(score, maxScore) {
  if (score == null) return null;
  if (maxScore == null) return String(score);
  const formatPart = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return String(value);
    if (Number.isInteger(num)) return String(num);
    return String(Math.round(num * 100) / 100);
  };
  return `${formatPart(score)}/${formatPart(maxScore)}`;
}

export function resolveModuleIndexForScreening(screeningMeta, moduleId) {
  const modules = Array.isArray(screeningMeta?.assessmentModules) ? screeningMeta.assessmentModules : [];
  const idx = modules.findIndex((mod) => String(mod.moduleId) === String(moduleId));
  return idx >= 0 ? idx : 0;
}
